import axios from 'axios'
import criarToast from './ToastsHandler'
import { recuperarCookie, removerCookie } from './CookiesHandler'
import router from "../../router";

const HttpClient = axios.create({
    baseURL: process.env.VUE_APP_ROOT_API
});

HttpClient.interceptors.request.use(request => {
    if (!request.url.endsWith('login')) {
        request.headers.common['Authorization'] = `Bearer ${recuperarCookie('provedores-token')}`

        const provedorAtivo = localStorage.getItem('provedorAtivo');
        if (provedorAtivo) {
            request.headers['X-Provedor-Id'] = provedorAtivo
        }
    }

    return request;
});


HttpClient.interceptors.response.use(
    response => {
        const metodo = response.config.method
        const mensagemSucesso = response.data?.message?.success

        if (metodo !== 'get' && Array.isArray(mensagemSucesso)) {

            const mensagensValidas = mensagemSucesso.filter(m => !!m)

            if (mensagensValidas.length > 0) {

                if (response.config.url.includes('/integracao/wf1')) {
                    if (Array.isArray(response.data.data) && response.data.data.length > 0) {
                        mensagensValidas.forEach(msg => {
                            criarToast({ tipo: 'success', mensagem: msg })
                        })
                    }
                } else {
                    mensagensValidas.forEach(msg => {
                        criarToast({ tipo: 'success', mensagem: msg })
                    })
                }
            }
        }

        return response
    },

    async (error) => {

        if (error.response?.status === 401) {
            if (router.history.current.name === 'login') {
                let dataErrors = error.response.data.message?.errors
                mostrarMensagensErro(dataErrors)
                return Promise.reject(error);
            }

            criarToast({
                tipo: 'error',
                mensagem: 'Por favor, faça login novamente!'
            });

            await removerCookie('provedores-token')
            router.push(`/login?logout=true&redirect_to=${router.currentRoute.path}`);
            return Promise.reject(error);
        }


        if (error.response?.data) {

            let dataErrors = error.response.data.message?.errors

            if (dataErrors) {
                mostrarMensagensErro(dataErrors)
            } else {
                dataErrors = error.response.data.mensagem

                if (typeof dataErrors !== 'undefined') {
                    dataErrors.forEach(msg => {
                        criarToast({
                            tipo: 'error',
                            mensagem: msg
                        });
                    })
                } else {

                    if (typeof error.response.data === 'object') {
                        dataErrors = error.response.data.message?.errors?.[0] || error.response.data;
                    } else {
                        try {
                            const parsedData = JSON.parse(error.response.data);
                            dataErrors = parsedData.message?.errors?.[0];
                        } catch (e) {
                            dataErrors = error.response.data;
                        }
                    }

                    if (typeof dataErrors == 'string') {
                        criarToast({
                            tipo: 'error',
                            mensagem: dataErrors
                        });

                    } else if (typeof dataErrors == 'object' && dataErrors !== null) {
                        Object.keys(dataErrors).forEach(key => {
                            const errorValue = dataErrors[key];
                            if (Array.isArray(errorValue)) {
                                errorValue.forEach(msg => {
                                    criarToast({
                                        tipo: 'error',
                                        mensagem: msg
                                    });
                                });
                            } else {
                                criarToast({
                                    tipo: 'error',
                                    mensagem: errorValue
                                });
                            }
                        });
                    }
                }
            }
        }

        if (error.response?.status === 500) {
            criarToast({
                tipo: 'error',
                mensagem: 'Houve um erro com o servidor, tente novamente e se o erro persistir, contate o suporte.'
            });
        }

        return Promise.reject(error)
    }
)

function mostrarMensagensErro(dataErrors) {
    dataErrors.map(err => {
        if (typeof err === "string") {
            criarToast({
                tipo: 'error',
                mensagem: err
            });
        } else {
            const errorKeys = Object.keys(err)
            errorKeys.forEach(key => {
                err[key].forEach(message => {
                    criarToast({
                        tipo: 'error',
                        mensagem: message
                    });
                })
            })
        }
    })
}

export default HttpClient;
